import type { ComponentChildren } from "preact";
import { useState } from "preact/hooks";

import { Header } from "./components/Header";
import { BottomNav } from "./components/BottomNav";
import { useScanStatus } from "./hooks/useJobs";

interface Props {
  children: ComponentChildren;
  onOpenSettings: () => void;
  onOpenAddCompany: () => void;
  onOpenDiagnostics: () => void;
}

/** AppShell — top-level responsive layout.
 *
 * Phase 4: responsive Header (hamburger drawer on mobile) + BottomNav
 * (mobile only). The Header actions (Add Company / Settings / Scan /
 * Diagnostics) are passed in by the parent so the App component can
 * own the modal/drawer open state.
 */
export function AppShell({ children, onOpenSettings, onOpenAddCompany, onOpenDiagnostics }: Props) {
  const startScan = useScanStatus();

  return (
    <div class="app-shell">
      <Header
        onStartScan={startScan}
        onOpenSettings={onOpenSettings}
        onOpenAddCompany={onOpenAddCompany}
        onOpenDiagnostics={onOpenDiagnostics}
      />
      <main class="app-main">{children}</main>
      <BottomNav onOpenSettings={onOpenSettings} />
    </div>
  );
}
